import { Constants } from '@leverege/molten-core';
import Theme from "./Theme.js";
import Router from "./Router.js";
import DragAndDrop from "./DragAndDrop.js";
import Logout from "./Logout.js";
import IntercomInit from "./IntercomInit.js";
import IntercomLogin from "./IntercomLogin.js";
import Sentry from "./Sentry.js"; // eslint-disable-next-line import/no-cycle
import ReleaseMonitor from "./ReleaseMonitor.js";
import CleanupPreload from "./CleanupPreload.js";
import UserSettings from "./UserSettings.js";
import FetchIntercept from "./FetchIntercept.js";
import I18N from "./I18N.js";
import SetMetaViewport from "./SetMetaViewport.js";
const {
  INITIALIZER,
  PROVIDER,
  REDUX_MIDDLEWARE,
  SUPPORT_COMPONENTS,
  LOGGED_IN,
  LOGGED_OUT
} = Constants;
const install = molten => {
  molten.addPlugin(INITIALIZER, I18N);
  molten.addPlugin(INITIALIZER, FetchIntercept);
  molten.addPlugin(INITIALIZER, Sentry);
  molten.addPlugin(INITIALIZER, SetMetaViewport);
  molten.addPlugin(LOGGED_IN, Sentry);
  molten.addPlugin(LOGGED_OUT, Sentry);
  molten.addPlugin(LOGGED_IN, ReleaseMonitor);
  molten.addPlugin(INITIALIZER, Router);
  molten.addPlugin(PROVIDER, Theme);
  molten.addPlugin(SUPPORT_COMPONENTS, Theme);
  molten.addPlugin(PROVIDER, DragAndDrop);
  molten.addPlugin(LOGGED_OUT, Logout);
  molten.addPlugin(LOGGED_IN, UserSettings);
  molten.addPlugin(INITIALIZER, IntercomInit);
  molten.addPlugin(LOGGED_IN, IntercomLogin);
  molten.addPlugin(LOGGED_OUT, IntercomLogin);
  molten.addPlugin(LOGGED_IN, CleanupPreload);
  molten.addPlugin(REDUX_MIDDLEWARE, CleanupPreload);
};
export default {
  install
};